import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { useTrackGooglePromptUsedPreSignup } from '../google-authentication/google-prompt/googlePromptTracking';
import { BasicViewContainer } from './BasicViewContainer';
import { FramedViewContainer } from './FramedViewContainer';
import { useTrackPopupBlocked } from '../hooks/useTrackPopupBlocked';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewContainer = () => {
  useTrackGooglePromptUsedPreSignup();
  useTrackPopupBlocked();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const Container = isInstanceOfSignupEmbedder ? FramedViewContainer : BasicViewContainer;
  return /*#__PURE__*/_jsx(Container, {});
};